<div class="flex flex-col gap-5">
    <!-- Header -->
    <div class="flex flex-row justify-between items-center">
        <h5 [@first] class="text-zen font-medium text-3xl">
            {{ "txt_users" | translate: language:ModuleNames.Common }}
        </h5>
        <button class="btn exp uppercase leading-12 rounded px-5" (click)="onAddUser()">
            {{ "btn_add_user" | translate: language:ModuleNames.Common }}
        </button>
    </div>

    <!-- Table -->
    <div class="my-8 py-5">
        <t-table *ngIf="users" [options]="usersOptions">
            <ng-template #cellTempate let-element let-column="column" let-colIndex="colIndex">
                <!-- User Name Column -->
                <ng-container *ngIf="column.field == 'first'; else second">
                    <h5 class="max-w-xs truncate text-sm text-zen leading-20">
                        {{ element.firstName + " " + element.lastName }}
                    </h5>
                </ng-container>

                <!-- Companies Column -->
                <ng-template #second>
                    <ng-container *ngIf="column.field == 'second'; else third">
                        <h5 class="max-w-xs truncate text-sm text-zen leading-20"
                            [matTooltip]="element.role == 'Super Admin' ? ('All registered companies' | translate: language:ModuleNames.Common) : extractUserCompanies(element)">
                            {{ element.role == "Super Admin"
                            ? ("All registered companies" | translate: language:ModuleNames.Common)
                            : extractUserCompanies(element) }}
                        </h5>
                    </ng-container>
                </ng-template>

                <!-- Status Column -->
                <ng-template #third>
                    <ng-container *ngIf="column.field == 'third'; else options">
                        <h5 class="max-w-xs truncate text-sm text-zen leading-20">
                            {{ (element.isActive ? "txt_active" : "txt_inactive") | translate:
                            language:ModuleNames.Common }}
                        </h5>
                    </ng-container>
                </ng-template>

                <!-- Options Menu -->
                <ng-template #options>
                    <ng-container *ngIf="column.field == 'options'">
                        <div class="flex flex-row justify-end items-center gap-2 h-full">
                            <i [ZMenuTriggerFor]="menu"
                                class="fal font-normal fa-ellipsis-h h-9 w-9 leading-9 bg-white text-zen rounded-full btn text-center"></i>
                            <z-menu #menu>
                                <menuItems>
                                    <!-- Active User Options -->
                                    <ng-container *ngIf="element.isActive">
                                        <a MenuItem (click)="onEditUser(colIndex, element)">
                                            <i class="fal fa-pen mx-1"></i>
                                            {{ "btn_leaver_list_edit" | translate: language:ModuleNames.Common }}
                                        </a>
                                        <a *ngIf="currentUser.role == UserRoles.SuperAdmin" MenuItem
                                            [disabled]="!element.isActive" (click)="onChangePassword(element)">
                                            <i class="fal fa-key mx-1"></i>
                                            {{ "txtChangePassword" | translate: language:ModuleNames.Common }}
                                        </a>
                                        <!-- <a *ngIf="currentUser.role == UserRoles.SuperAdmin" MenuItem
                                            [disabled]="!element.isActive" (click)="onChangeEmail(element)">
                                            <i class="fal fa-key mx-1"></i>
                                            {{ "txtChangeEmail" | translate: language:ModuleNames.Common }}
                                        </a> -->
                                        <a MenuItem [disabled]="!element.isActive"
                                            (click)="onResetPassword(element.email)">
                                            <i class="fal fa-undo mx-1"></i>
                                            {{ "txtResetPassword" | translate: language:ModuleNames.Common }}
                                        </a>
                                        <a MenuItem delete *ngIf="currentUser.key != element.key && element.isActive"
                                            (click)="onDeactivateUser(element)">
                                            <i class="fal fa-trash mx-1"></i>
                                            {{ "txt_deactivate" | translate: language:ModuleNames.Common }}
                                        </a>
                                    </ng-container>

                                    <!-- Inactive User Options -->
                                    <ng-container *ngIf="!element.isActive">
                                        <a MenuItem (click)="onActivateUser(element)">
                                            <i class="fal fa-undo mx-1"></i>
                                            {{ "txt_activate" | translate: language:ModuleNames.Common }}
                                        </a>
                                    </ng-container>
                                </menuItems>
                            </z-menu>
                        </div>
                    </ng-container>
                </ng-template>
            </ng-template>
        </t-table>

        <!-- Empty State -->
        <EmptySection *ngIf="users && users.length == 0"></EmptySection>
    </div>
</div>